import { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';

let observer = null;

const LOAD_IMG_EVENT_TYPE = 'loadImage';

const onIntersection = (entries, io) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      io.unobserve(entry.target);
      entry.target.dispatchEvent(new CustomEvent(LOAD_IMG_EVENT_TYPE));
    }
  });
};

// TODO: width, height 규격 정하기
const Image = ({
  lazy,
  threshold,
  placeholder,
  src,
  block,
  width,
  height,
  alt,
  mode,
  ...props
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const imgRef = useRef(null);

  const imageStyle = {
    display: block ? 'block' : undefined,
    width,
    height,
    objectFit: mode,
  };

  useEffect(() => {
    if (!lazy) {
      setIsLoading(true);
      return;
    }

    const handleLoadImage = () => setIsLoading(true);

    const imgElement = imgRef.current;
    if (imgElement) {
      imgElement.addEventListener(LOAD_IMG_EVENT_TYPE, handleLoadImage);
    }

    return () => {
      imgElement.removeEventListener(LOAD_IMG_EVENT_TYPE, handleLoadImage);
    };
  }, [lazy]);

  useEffect(() => {
    if (!lazy) {
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(onIntersection, { threshold });
    }

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }
  }, [lazy, threshold]);

  return (
    <img
      ref={imgRef}
      src={isLoading ? src : placeholder}
      style={{ ...props.style, ...imageStyle }}
      alt={alt}
    />
  );
};

Image.defaultProps = {
  lazy: false,
  threshold: 0.5,
  block: false,
  style: {},
};

Image.propTypes = {
  lazy: PropTypes.bool,
  threshold: PropTypes.number,
  placeholder: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  block: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  alt: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(['cover', 'fill', 'contain']).isRequired,
  style: PropTypes.object,
};

export default Image;
